import { ICompany, IDoc } from "../interfaces/document";

export interface StatusConfig {
  status: string;
  title: string;
}

export function getDocStatus(doc: IDoc, userCompany?: ICompany): StatusConfig {
  if (doc.cancelled) {
    return { status: "cancelled", title: "Скасований" };
  }

  if (doc.counterparties?.some((c) => c.cancelled)) {
    return { status: "cancelled", title: "Скасований контрагентом" };
  }

  if (doc.error) {
    if (doc.error.code === 115) {
      return { status: "loading", title: "Підписується..." };
    }
    return { status: "failure", title: "Помилка" };
  }

  const ownerHasNonStamp = doc.signatures?.some((s) => !s.stamp) ?? false;
  const ownerHasStamp = doc.signatures?.some((s) => s.stamp) ?? false;
  const ownerSigned = doc.signatures?.length > 0;
  const hasCounterparties = doc.counterparties?.length > 0;
  const allCounterpartiesSigned =
    hasCounterparties && doc.counterparties.every((c) => c.signatures.length > 0);
  const someCounterpartyUnsigned =
    hasCounterparties && doc.counterparties.some((c) => c.signatures.length === 0);

  if (!ownerSigned) {
    const hasType = !!doc.type?.title;
    const hasRequiredAttributes = doc.attributes?.every((a) =>
      a.mandatory ? !!a.value : true,
    );
    if (hasCounterparties && hasType && hasRequiredAttributes) {
      return { status: "readyToSign", title: "Готовий для підпису і надсилання" };
    }
    return { status: "wait", title: "Очікує вашого підпису" };
  }

  if (ownerHasNonStamp && !ownerHasStamp && userCompany?.stamp) {
    return { status: "wait", title: "Очікує вашої печатки" };
  }

  if (ownerSigned && !hasCounterparties) {
    return { status: "success", title: "Підписаний вами" };
  }

  if (ownerSigned && someCounterpartyUnsigned) {
    return { status: "success", title: "Очікує підпису контрагента" };
  }

  if (ownerSigned && allCounterpartiesSigned) {
    return { status: "successAll", title: "Підписаний всіма" };
  }

  return { status: "wait", title: "Очікує вашого підпису" };
}
